import { faArrowUpRightFromSquare } from "components/icon-library";
import { ColumnInterface } from "components/tables/interfaces";
import Table from "components/tables/table";
import { addUserColumns } from "lib/schema";
import { ListEntity } from "models/list-entity";
import { ListUser } from "models/list-user";
import { FunctionComponent } from "react";
import { useNavigate } from "react-router";
import { useList } from "stores/hooks/list";
import { useLocale } from "stores/hooks/locale";
import { useTranslate } from "stores/hooks/translation";

interface UsersTableProps {
  users: ListUser[];
  listEntities: ListEntity[];
}

const UsersTable: FunctionComponent<UsersTableProps> = ({
  users,
  listEntities,
}) => {
  const list = useList();
  const locale = useLocale();
  const translate = useTranslate();
  const navigate = useNavigate();

  if (!list) {
    return null;
  }

  // get columns
  const { schema = [] } = list;
  const columns: ColumnInterface[] = [];
  addUserColumns(schema, locale, listEntities, columns, translate);

  const onOpen = async (user: ListUser) => {
    if (user.status === "approved") {
      navigate(`/shared/list/${list.uuid}/user/${user.uuid}`);
    }
  };

  return (
    <Table
      name={`shared-list-${list.uuid}`}
      columns={columns}
      data={users}
      editers={[
        {
          onClick: onOpen,
          icon: faArrowUpRightFromSquare,
          isDisabled: (user: ListUser) => user.status !== "approved",
        },
      ]}
    />
  );
};

export default UsersTable;
